import { useState, type FormEvent } from "react";
import { Users } from "@/lib/icons";
import { Button } from "@/components/ui/button";
import { PRIVACY_COPY } from "@/constants/privacy";

/**
 * Two-nickname form used by every hot-seat game. Trims & length-caps input;
 * blank names fall back to "Player 1" / "Player 2" inside useHotSeatMatch.
 */
export default function PlayerSetup({
  title,
  description,
  ctaLabel = "Start match",
  onStart,
}: {
  title: string;
  description: string;
  ctaLabel?: string;
  onStart: (p1: string, p2: string) => void;
}) {
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");

  const submit = (e: FormEvent) => {
    e.preventDefault();
    onStart(p1, p2);
  };

  return (
    <div className="max-w-md mx-auto rounded-xl border border-border bg-card p-6">
      <div className="flex items-center gap-2 mb-1">
        <Users size={16} className="text-primary" aria-hidden="true" />
        <h2 className="text-lg font-semibold text-foreground">{title}</h2>
      </div>
      <p className="text-sm text-muted-foreground mb-5">{description}</p>

      <form onSubmit={submit} className="space-y-4">
        <div>
          <label
            htmlFor="player1-name"
            className="block text-xs font-medium text-foreground mb-1.5"
          >
            Player 1
          </label>
          <input
            id="player1-name"
            type="text"
            value={p1}
            onChange={(e) => setP1(e.target.value)}
            placeholder="Nickname"
            maxLength={24}
            autoFocus
            className="w-full h-10 px-3 rounded-md border border-input bg-background text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          />
        </div>
        <div>
          <label
            htmlFor="player2-name"
            className="block text-xs font-medium text-foreground mb-1.5"
          >
            Player 2
          </label>
          <input
            id="player2-name"
            type="text"
            value={p2}
            onChange={(e) => setP2(e.target.value)}
            placeholder="Nickname"
            maxLength={24}
            className="w-full h-10 px-3 rounded-md border border-input bg-background text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          />
        </div>

        <Button type="submit" className="w-full">
          {ctaLabel}
        </Button>

        <p className="text-[11px] text-muted-foreground text-center">
          {PRIVACY_COPY.sessionNamesNote}
        </p>
      </form>
    </div>
  );
}